export default __webpack_public_path__ + "static/media/wall-clock.933ede64.svg";